import React from 'react';
import './Button.css';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success' | 'accent';
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  full?: boolean;
  loading?: boolean;
  /** Render as a different HTML element (e.g. 'a') */
  as?: 'button' | 'a';
  href?: string;
}

function Button({
  variant = 'primary',
  size = 'md',
  full = false,
  loading = false,
  as: Tag = 'button',
  href,
  disabled,
  children,
  className = '',
  ...rest
}: ButtonProps) {
  const classes = [
    'ui-btn',
    `ui-btn--${variant}`,
    `ui-btn--${size}`,
    full ? 'ui-btn--full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const isDisabled = disabled || loading;

  const content = (
    <>
      {loading && <span className="ui-btn__spinner" aria-hidden="true" />}
      {children}
    </>
  );

  if (Tag === 'a') {
    return (
      <a
        className={classes}
        href={href}
        aria-disabled={isDisabled ? 'true' : undefined}
        {...(rest as unknown as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {content}
      </a>
    );
  }

  return (
    <button className={classes} disabled={isDisabled} {...rest}>
      {content}
    </button>
  );
}

export default Button;
